module.exports = __webpack_public_path__ + "img/MTABAPPVITALS.0b8f2ed1.jpg";